import comp from "./AssignmentActivity";
export default comp;
